import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ba9461a")

_pushScopeId("data-v-6ba9461a")
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "On", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " Please leave a detailed description below as to what went wrong and how I can reproduce the issue. Hopefully I'll be able to fix it soon! ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ContactForm = _resolveComponent("ContactForm")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h2", null, _toDisplayString(_ctx.appName), 1),
    _hoisted_3,
    _createVNode(_component_ContactForm, {
      appName: _ctx.appName,
      contactType: "bugReport"
    }, null, 8, ["appName"])
  ]))
})